import { cn } from "@/lib/cn";
import { DysonLogo } from "@/components/ui/DysonLogo";

interface BrandLockupProps {
  variant?: "stacked" | "inline" | "mark-only";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeMap = {
  sm: { logo: "h-6 w-6", text: "text-sm", gap: "gap-1.5" },
  md: { logo: "h-9 w-9", text: "text-xl", gap: "gap-2" },
  lg: { logo: "h-14 w-14", text: "text-3xl", gap: "gap-3" },
};

export function BrandLockup({ variant = "inline", size = "md", className }: BrandLockupProps) {
  const s = sizeMap[size];

  if (variant === "mark-only") {
    return (
      <div className={cn("flex items-center justify-center", className)}>
        <DysonLogo className={s.logo} />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center",
        variant === "stacked" ? `flex-col ${s.gap}` : `flex-row ${s.gap}`,
        className,
      )}
    >
      <DysonLogo className={s.logo} />
      <span
        className={cn(
          "font-bold uppercase tracking-[0.15em] text-fg select-none",
          s.text,
        )}
      >
        OMNI
      </span>
    </div>
  );
}
